export default (path, file = false) => {
  return () => {
    return import(`@/pages/${path || ''}${path ? '/' : ''}${file || 'index'}.vue`)
  }
}
